import React from "react";
import StackedContent from "@/components/StackedContent/StackedContent";
import Button from "@/components/Button/Button";
import { RedirectIcon } from "@/components/MenusIcons/MenusIcons";
import VidyardPlayer from "../VidyardPlayer/VidyardPlayer";

interface OlsVideoSectionProps {
  header: string;
  description: React.ReactNode;
  videoUrl: string; 
  buttonText?: string;
  linkUrl?: string;
  reverse?: boolean; 
}

const OlsVideoSection: React.FC<OlsVideoSectionProps> = ({
  header,
  description,
  videoUrl,
  buttonText,
  linkUrl,
  reverse = false,
}) => {
  return (
    <>
      <StackedContent>
        <StackedContent.Col1 cols="5" desktopOrder={reverse ? "2" : "1"}>
          <div className="video-wrapper">
            {videoUrl && (
                <VidyardPlayer uuid={videoUrl} type="lightbox" />
            )}
          </div>
        </StackedContent.Col1>

        <StackedContent.Col2 cols="5" desktopOrder={reverse ? "1" : "2"}>
            <h2 className="color-primary">{header}</h2>
            <p className="body-m">{description}</p>
            {buttonText && linkUrl && (
              <div className="btn-section">
                <Button
                  label={buttonText}
                  icon={<RedirectIcon />}
                  iconPosition="after"
                  size="lg"
                  variant="fill"
                  width="fit-content"
                  linkUrl={linkUrl}
                  linkTarget="_blank"
                />
              </div>
            )}
        </StackedContent.Col2>
      </StackedContent>

    </>
  );
};

export default OlsVideoSection;
